var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M18.549 1.43C17.624.505 16.404 0 15.1 0c-1.304 0-2.523.505-3.448 1.43l-2.25 2.228c-.442.442-.442 1.136 0 1.556.441.442 1.135.442 1.556 0l2.229-2.228c1.009-1.01 2.775-1.01 3.763 0 1.03 1.03 1.03 2.733 0 3.763l-3.68 3.743c-1.009 1.009-2.775 1.009-3.763 0-.441-.442-1.135-.442-1.556 0-.441.441-.441 1.135 0 1.555.925.925 2.145 1.43 3.448 1.43 1.304 0 2.523-.505 3.448-1.43l3.722-3.721C19.495 7.4 20 6.18 20 4.878c0-1.304-.526-2.523-1.451-3.448z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M9.004 14.738l-2.229 2.25c-1.03 1.03-2.733 1.03-3.763 0-1.03-1.03-1.03-2.734 0-3.764l3.721-3.721c1.03-1.03 2.733-1.03 3.764 0 .441.441 1.135.441 1.556 0 .441-.442.441-1.136 0-1.556-1.914-1.914-5.004-1.914-6.897 0l-3.721 3.7c-1.913 1.913-1.913 5.004 0 6.896.946.946 2.208 1.43 3.448 1.43 1.24 0 2.502-.484 3.448-1.43l2.229-2.228c.441-.442.441-1.136 0-1.556-.42-.442-1.115-.442-1.556-.021z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.a6b2d57d.svg";
export { ForwardRef as ReactComponent };